import React, { useState } from 'react';
import {
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import { Button } from 'components/ui/button';
import { MeetingTimePicker } from './MeetingTimePicker';
import { HostAvailabilityRecord } from './types';
import { MeetingListSkeleton } from './MeetingListSkeleton';
import { DEFAULT_AVATAR_IMG_URL } from '../HealthCoachDashboard/constants';
import { MeetingListEmptyState } from './MeetingListEmptyState';

type Props = {
  isError: boolean;
  isFetching: boolean;
  isSubmitting: boolean;
  meetings: HostAvailabilityRecord;
  onSubmit: (selectedTime: string, selectedHostId: string) => void;
  timezone: string;
};

export const MeetingList = ({
  isError,
  isFetching,
  isSubmitting,
  meetings,
  onSubmit,
  timezone,
}: Props) => {
  const [selectedHostTime, setSelectedHostTime] = useState<{
    hostId: string;
    time: string;
  } | null>(null);

  const meetingHostIds = Object.keys(meetings ?? {});

  return (
    <VStack flex={1} w={'100%'}>
      <VStack
        height={'400px'}
        maxHeight={'400px'}
        overflow={'auto'}
        gap={'12px'}
      >
        {isFetching && <MeetingListSkeleton />}

        {meetings &&
          meetingHostIds.map((hostId) => {
            const { hostInfo, times } = meetings?.[hostId];

            return (
              <MeetingTimePicker
                key={hostId}
                hostAvatarUrl={hostInfo?.image_url || DEFAULT_AVATAR_IMG_URL}
                hostDisplayName={hostInfo?.display_name ?? ''}
                hostId={hostInfo?.id ?? ''}
                isError={isError}
                isSubmitting={isSubmitting}
                onSelectTime={(selectedHostTime) => {
                  const hostId = hostInfo?.id;
                  if (!hostId) return;

                  setSelectedHostTime({ hostId, time: selectedHostTime });
                }}
                selectedTime={selectedHostTime?.time}
                selectedHostId={selectedHostTime?.hostId}
                timeSlots={times}
                timezone={timezone}
              />
            );
          })}

        {!isFetching && meetings && meetingHostIds.length === 0 && (
          <MeetingListEmptyState />
        )}
      </VStack>

      <Button
        alignSelf={'center'}
        bgColor={'secondary.500'}
        h={'44px'}
        disabled={isFetching || !selectedHostTime}
        loading={isSubmitting}
        minH={'44px'}
        onClick={() => {
          if (!selectedHostTime) return;

          onSubmit(selectedHostTime.time, selectedHostTime.hostId);
        }}
        mt={3}
        w={'100%'}
      >
        <Text color={'white'} fontWeight={'bold'}>
          Book Appointment
        </Text>
      </Button>
    </VStack>
  );
};
